module.exports = __webpack_public_path__ + "061cbaf232a2f2df62f6162083b518d6.png";